import { api } from "../Intercepter";

interface GetAllPhoneBookParams {
  currentPage: number;
  limit: number;
  search: string;
  clientName: string | undefined;
  genderNull: string | undefined;
  labelId?: number | undefined;
}

export const getAllPhoneBook = async ({
  currentPage,
  limit,
  search,
  clientName,
  genderNull,
  labelId,
}: GetAllPhoneBookParams) => {
  let response = await api.get<GetAllPhoneBookResponse>(
    `/clients?relations[]=phones&&&relations[]=clientLabels`,
    {
      params: {
        offset: currentPage * limit,
        limit: limit,
        q: search,
        clientName: clientName,
        gender_null: genderNull,
        ...(labelId ? { labelId } : {}),
      },
    }
  );

  if (!response) {
    throw new Error("Error in getting all phone book");
  }

  return response.data as GetAllPhoneBookResponse;
};

export interface GetAllPhoneBookResponse {
  array: User[];
  locations: any[];
  count: number;
}

export interface User {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  fullName: string;
  email: any;
  notes: string;
  neighborhoodId: any;
  subCityId: any;
  cityId: any;
  gender?: string;
  isBlcoked: boolean;
  phones: Phone[];
  region?: Region;
  city?: City;
  location: any;
  appClient: any;
  displacedPerson?: {
    id: number;
    sessionName?: string | null;
    otherNote?: string | null;
    field1?: string | null;
    isReturnee?: boolean | null;
    fullName?: string | null;
  } | null;
  clientLabels?: Array<{
    id: number;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    labelId: number;
    clientId: number;
    label: {
      id: number;
      createdAt: string;
      updatedAt: string;
      deletedAt: string | null;
      name: string;
    };
  }>;
}

export interface Phone {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  phoneNumber: string;
  clientId: string;
}

export interface Region {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  cityId: string;
  regionName: string;
}

export interface City {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  governorateId: string;
  cityName: string;
}
